import * as React from 'preact/compat'
import styles from '../../../css/auth.pcss.json'

const domain = window.sgDomain || ''

const Consent = () => <p className={styles['auth-consent']}>Авторизуясь, ты соглашаешься с <a target="_blank" href={`${domain}/site_help#za_chto_moderaciya_karaet_polzovateley`}>правилами сайта</a> и <a target="_blank" href={`${domain}/rules`}>пользовательским соглашением</a>.</p>

export default Consent
